import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CommonCard from '../../../common/Pilots/CommonCard/CommonCard';
import './VirtualClassroom.scss';	
import {VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH} from '../../../../helper/APIPaths';
import { setData, setsubCategoryNameOrItemName } from '../../../../storage/reducers/virtualClassRoomOrEngines';
import CircularLoader from '../../../common/Loader/CircularLoader';
import { useTranslation } from 'react-i18next';
import { APP_TITLES, COMMON_MESSAGES, VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS } from '../../../../helper/constants';
import { isPilot } from '../../../../helper/commonFunctions';
import { setMenuSelection } from '../../../../storage/reducers/menuSelectorReducer';


const VirtualClassroom: React.FC = ()=>{
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [elements, setElements] = useState<Array<object>>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);
    const { userInformation } = useSelector((state: any) => state?.userInformation);
    const { dataCardVirtualClassrooms } = useSelector((state:any) => state.virtualClassRoomsOrEngines);
    const{ weather_radar } = VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS;
    
    useEffect(() => {
        if (dataCardVirtualClassrooms?.length > 0) {
            setElements(dataCardVirtualClassrooms);
            setLoading(false);
            setError(false);
        } else if (!hasFetched) {
            fetchVirtualClassroomElements();
            setHasFetched(true);
        }
        dispatch(setMenuSelection({currentMenuTitle: APP_TITLES.VIRTUAL_CLASSROOMS}));
    }, [dataCardVirtualClassrooms]);

     const fetchVirtualClassroomElements = useCallback(async () => {
            try {
                const { category, pilot_category_name_VC } = VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS;
                const response = await fetch(VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH,{
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(
                        {
                            type: category, 
                            pilot_category_name: pilot_category_name_VC,
                            role : isPilot(userInformation?.jobTitle || ""),
                        }
                ),
                });
                const res = await response.json();
                const data = res?.data;
                if (data) {
                    const sortedData = data?.preflightData.sort((a, b) => {
                        if (a.id.toLowerCase() < b.id.toLowerCase()) return -1;
                        if (a.id.toLowerCase() > b.id.toLowerCase()) return 1;
                        return 0;
                    });
                    dispatch(setData({dataCardVirtualClassrooms:sortedData}));
                    setLoading(false);
                    setError(false);
                }
            } catch (ierror) {
                console.error("Error while fetching virtual classrooms data", ierror);
                setLoading(false);
                setError(true);
            }
        }, []);
        
    const handleElementClick = (element:any, index:number) => {
        console.log("Element clicked:", element, index);
        dispatch(setsubCategoryNameOrItemName({subCategoryNameVirtualClassrooms: element?.id}));  

        if(element?.id.toLowerCase() === weather_radar) {
            navigate(`/virtualclassroomsDetail`);
        }else{
            dispatch(setsubCategoryNameOrItemName({itemName: VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS.pilot_item_name_engines})); 
            navigate(`/virtualclassroomsDetailList`);
        }
       
    };

    const elementsList = elements?.map((element:any, index:number) => { 
        const updatedElement = {
            ...element, // copy all properties from the original element
            id: element?.id, // Overwrite `id` property
            title: `${element?.id}`, // adds or overwrites `title` property
            type: "virtualclassrooms", // adds or overwrites `type` property
            action: () => handleElementClick(element, index), // defines the action to be performed on click
        };
        return <CommonCard key={index} {...updatedElement} />;
    });

    return (
        <div className='virtualClassroomContainer'>
            {loading && <CircularLoader />}
            {elements.length > 0 &&
                <div className='virtualClassroomList'>
                    {elementsList}
                </div>
            } 
            {(error || (!loading && elements.length === 0)) && (
                <div className='error'>{t(COMMON_MESSAGES.NO_DATA_AVAILABLE)}</div>
            )}
        </div>
       
    );
};

export default VirtualClassroom;